import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";

import classNames from "classnames";

import UserForm from "./components/UserForm";
import UserSelector from "./components/UserSelector";
import { UsersProvider } from "./contexts/Users";

const Users = (): React.JSX.Element => {
    const [isAddingUser, setIsAddingUser] = useState<boolean>(false);

    return (
        <section>
            <Row>
                <Col>
                    <Button
                        className={classNames("mb-2")}
                        onClick={() => setIsAddingUser(true)}
                    >
                        Add new user
                    </Button>
                </Col>
            </Row>
            <Row>
                <UsersProvider
                    isAddingUser={isAddingUser}
                    setIsAddingUser={setIsAddingUser}
                >
                    <UserSelector />
                    <UserForm />
                </UsersProvider>
            </Row>
        </section>
    );
};

export default Users;
